/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Material_Merge_ButtonInputs */

const vi_order_material_merge_button = /** @type {(inputs: Order_Material_Merge_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gộp giá`)
};

/**

* @param {Order_Material_Merge_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_material_merge_button = /** @type {((inputs?: Order_Material_Merge_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Material_Merge_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_material_merge_button(inputs)
});